/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { arrowRight } from "../assets/arrow-right";
import { Icon, type IconBaseProps } from "../icon";

export const IconArrowRight = (props: IconBaseProps) => <Icon {...props} svg={arrowRight} />;

IconArrowRight.displayName = "IconArrowRight";
